import { useUserName } from '../../contexts/userName';
import { Link } from 'react-router-dom';
import './style.scss';

const reviewAreas = [
  {
    icon: 'fact_check',
    title: 'Evidencias',
    description: 'Verifica que los soportes cumplan los criterios definidos.',
    accent: 'violet',
    path: '/revisor/evidencias'
  },
  {
    icon: 'crisis_alert',
    title: 'Evidencias de incidencia',
    description: 'Revisa bitácoras, fichas metodológicas y asistencias de las acciones de incidencia.',
    accent: 'mint',
    path: '/revisor/evidencias-incidencia',
    action: 'Revisar acciones de incidencia'
  },
  {
    icon: 'group',
    title: 'Caracterizaciones',
    description: 'Contrasta la información registrada antes de validarla.',
    accent: 'coral',
    path: '/revisor/caracterizaciones',
    action: 'Ver personas y consentimientos'
  },
  {
    icon: 'clinical_notes',
    title: 'Asistencias',
    description: 'Revisa consistencia, soportes y novedades de cada encuentro.',
    accent: 'mint'
  }
];

function ReviewerDashboard() {
  const { userName } = useUserName();
  const firstName = String(userName || 'Revisor').trim().split(/\s+/)[0];

  return (
    <section className='reviewer-dashboard'>
      <aside className='reviewer-dashboard__rail' aria-label='Panel de revisión'>
        <div className='reviewer-dashboard__brand'>
          <span className='material-symbols-rounded'>verified_user</span>
          <span>Revisión</span>
        </div>

        <nav className='reviewer-dashboard__nav'>
          <button type='button' className='is-active'>
            <span className='material-symbols-rounded'>space_dashboard</span>
            Resumen
          </button>
          <Link to='/revisor/semaforo'>
            <span className='material-symbols-rounded'>calendar_view_week</span>
            Semáforo
          </Link>
          <Link to='/revisor/calendario'>
            <span className='material-symbols-rounded'>calendar_month</span>
            Calendario
          </Link>
          <Link to='/revisor/historial'>
            <span className='material-symbols-rounded'>history</span>
            Historial
          </Link>
        </nav>

        <p className='reviewer-dashboard__rail-note'>
          Perfil independiente para control de calidad y validación.
        </p>
      </aside>

      <div className='reviewer-dashboard__content'>
        <header className='reviewer-dashboard__welcome'>
          <div>
            <span className='reviewer-dashboard__eyebrow'>CENTRO DE REVISIÓN</span>
            <h1>Hola, {firstName}</h1>
            <p>
              Aquí tendrás una vista clara de los registros que requieren tu
              concepto.
            </p>
          </div>
          <div className='reviewer-dashboard__status'>
            <span></span>
            Sesión de revisor activa
          </div>
        </header>

        <section className='reviewer-dashboard__areas'>
          <div className='reviewer-dashboard__section-heading'>
            <div>
              <span className='reviewer-dashboard__eyebrow'>ÁREAS DE CONTROL</span>
              <h2>¿Qué podrás revisar?</h2>
            </div>
            <p>Consulta y valida sin alterar la gestión de mediadores.</p>
          </div>

          <div className='reviewer-dashboard__cards'>
            {reviewAreas.map(area => area.path ? (
              <Link
                to={area.path}
                className={`reviewer-dashboard__card reviewer-dashboard__card--${area.accent} is-clickable`}
                key={area.title}>
                <span className='material-symbols-rounded'>{area.icon}</span>
                <h3>{area.title}</h3>
                <p>{area.description}</p>
                <span className='reviewer-dashboard__card-action'>
                  {area.action || 'Explorar evidencias'}
                  <span className='material-symbols-rounded'>arrow_forward</span>
                </span>
              </Link>
            ) : (
              <article
                className={`reviewer-dashboard__card reviewer-dashboard__card--${area.accent}`}
                key={area.title}>
                <span className='material-symbols-rounded'>{area.icon}</span>
                <h3>{area.title}</h3>
                <p>{area.description}</p>
                <small>Disponible al recibir asignaciones</small>
              </article>
            ))}
          </div>
        </section>
      </div>
    </section>
  );
}

export default ReviewerDashboard;
